import * as React from 'react';
import { useSelector } from 'react-redux';
import { ContactsModalV2 } from '../../components/ContactsModalWindow';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { selectConsultantPhone, selectIsContactsModalOpen } from '../../selectors/consultantContacts';
import { setIsContactsModalOpen } from '../../slices';
import { formatPhone } from './utils/formatPhone';

export const ContactsModalV2Container = (): React.JSX.Element => {
  const isContactsModalOpen = useSelector(selectIsContactsModalOpen);
  const phone = useSelector(selectConsultantPhone);
  const dispatch = useAppDispatch();
  const formattedPhone = formatPhone(phone);

  const handleClose = React.useCallback(() => {
    dispatch(setIsContactsModalOpen(false));
  }, [dispatch]);

  return <ContactsModalV2 phone={formattedPhone} open={isContactsModalOpen || false} handleClose={handleClose} />;
};
